import React from 'react';

export function useEffectAfterMount(effect, deps) {
  const mounted = React.useRef(false);
  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    if (mounted.current) {
      const unmount = effect();
      return () => unmount && unmount();
    }
    mounted.current = true;
  }, deps);

  // Reset on unmount for the next mount.
  React.useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);
}
